import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddNoticeboardCategoryLayer from "../components/AddNoticeboardCategoryLayer";
 
 
const AddNoticeboardCategoryPage = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Noticeboard Category  </h5><Breadcrumb title="Add Noticeboard Category" /></div>
 
        {/* CalendarMainLayer */}
        <AddNoticeboardCategoryLayer />
 
    </>
  );
};
 
export default AddNoticeboardCategoryPage;
 
 